var map = {
	"./bg_light.png": "461c",
	"./bg_light2.png": "1755",
	"./bg_theme_item.png": "049e",
	"./bg_votebtn_blue.png": "9caa",
	"./bg_votebtn_gold.png": "ce72",
	"./btm_line_blue.png": "490c",
	"./btm_line_gold.png": "9e3e",
	"./confetti.png": "143e",
	"./de-de/result-btn_txt.png": "e900",
	"./de-de/visual_logo.png": "f349",
	"./de-de/visual_sublogo.png": "e914",
	"./de-de/vote-btn_txt.png": "178f",
	"./de-de/vote-btn_txt_end.png": "4113",
	"./de-de/vote-btn_txt_pre.png": "ff4d",
	"./en-gb/result-btn_txt.png": "2c91",
	"./en-gb/visual_logo.png": "ed58",
	"./en-gb/visual_sublogo.png": "84fd",
	"./en-gb/vote-btn_txt.png": "5145",
	"./en-gb/vote-btn_txt_end.png": "f6d2",
	"./en-gb/vote-btn_txt_pre.png": "8994",
	"./en-us/result-btn_txt.png": "9e55",
	"./en-us/visual_logo.png": "cd70",
	"./en-us/visual_sublogo.png": "d6e7",
	"./en-us/vote-btn_txt.png": "e74d",
	"./en-us/vote-btn_txt_end.png": "d25e",
	"./en-us/vote-btn_txt_pre.png": "62de",
	"./es-es/result-btn_txt.png": "2eda",
	"./es-es/visual_logo.png": "3f39",
	"./es-es/visual_sublogo.png": "b325",
	"./es-es/vote-btn_txt.png": "6f03",
	"./es-es/vote-btn_txt_end.png": "4373",
	"./es-es/vote-btn_txt_pre.png": "4f62",
	"./es-mx/result-btn_txt.png": "3b5e",
	"./es-mx/visual_logo.png": "ebc0",
	"./es-mx/visual_sublogo.png": "3137",
	"./es-mx/vote-btn_txt.png": "818e",
	"./es-mx/vote-btn_txt_end.png": "b32e",
	"./es-mx/vote-btn_txt_pre.png": "0778",
	"./fr-ca/result-btn_txt.png": "3ebf",
	"./fr-ca/visual_logo.png": "ec73",
	"./fr-ca/visual_sublogo.png": "8153",
	"./fr-ca/vote-btn_txt.png": "a0d5",
	"./fr-ca/vote-btn_txt_end.png": "2b18",
	"./fr-ca/vote-btn_txt_pre.png": "4515",
	"./fr-fr/result-btn_txt.png": "b7ff",
	"./fr-fr/visual_logo.png": "0338",
	"./fr-fr/visual_sublogo.png": "2894",
	"./fr-fr/vote-btn_txt.png": "101b",
	"./fr-fr/vote-btn_txt_end.png": "0b98",
	"./fr-fr/vote-btn_txt_pre.png": "dbd6",
	"./hero1_lossless.png": "4e16",
	"./hero2_lossless.png": "e19a",
	"./it-it/result-btn_txt.png": "e4ec8",
	"./it-it/visual_logo.png": "ca2b",
	"./it-it/visual_sublogo.png": "7825",
	"./it-it/vote-btn_txt.png": "0e42",
	"./it-it/vote-btn_txt_end.png": "21f4",
	"./it-it/vote-btn_txt_pre.png": "f5a3",
	"./ja-jp/result-btn_txt.png": "b00d",
	"./ja-jp/visual_logo.png": "2791",
	"./ja-jp/visual_sublogo.png": "ce9f",
	"./ja-jp/vote-btn_txt.png": "4de4b",
	"./ja-jp/vote-btn_txt_end.png": "2c23",
	"./ja-jp/vote-btn_txt_pre.png": "ecf9",
	"./pt-br/result-btn_txt.png": "bece",
	"./pt-br/visual_logo.png": "9f7a",
	"./pt-br/visual_sublogo.png": "789e",
	"./pt-br/vote-btn_txt.png": "ad88",
	"./pt-br/vote-btn_txt_end.png": "b34b",
	"./pt-br/vote-btn_txt_pre.png": "f192",
	"./result-btn.png": "e3c6",
	"./thumb_wallpaper_3times_lossless.png": "3d3e",
	"./thumb_wallpaper_5times_lossless.png": "23b8",
	"./top_line_blue.png": "5167",
	"./top_line_gold.png": "da66",
	"./visual_bg_light.png": "1981",
	"./visual_heroes_lossless.png": "5f1f",
	"./visual_heroes_post_lossless.png": "3534",
	"./visual_sublogo.png": "34c1",
	"./zh-tw/result-btn_txt.png": "bfac",
	"./zh-tw/visual_logo.png": "9916",
	"./zh-tw/visual_sublogo.png": "347c",
	"./zh-tw/vote-btn_txt.png": "c0b7",
	"./zh-tw/vote-btn_txt_end.png": "8a48",
	"./zh-tw/vote-btn_txt_pre.png": "e0ea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67bc";